import { useSelector } from "react-redux"
import Banner from "@/component/banner"

import Product from "./components/product"
import Teacher from "./components/teacher"
import Environment from "./components/environment"
import Reason from "./components/reason"
import Campus from "./components/campus"

function Index() {
  const { banners, classs, teachers, photos } = useSelector(
    (state) => state.page
  )
  return (
    <div className="home">
      <Banner banners={banners} />
      <Product classs={classs} />
      <Reason />
      <Teacher teachers={teachers} />
      <Environment photos={photos} />
      <Campus />
    </div>
  )
}

export default Index
